import { Component } from '@angular/core';

/**
 * Componente vuoto da passare come `customButton` a EbwModalService.openCustomModal(...)
 * quando si vuole solo nascondere il bottone "Chiudi" di default (es. perché il
 * componente ospitato ha già i suoi bottoni di azione/chiusura).
 *
 * A differenza di un componente creato a runtime con `Component({...})(class {})`,
 * questo è dichiarato normalmente (ModalModule) e quindi compilato in AOT — non
 * richiede il compilatore JIT, che non è disponibile nelle build di produzione.
 */
@Component({
  selector: 'ebw-monorepo-hidden-modal-button',
  template: ''
})
export class HiddenModalButtonComponent {}
